export function autoPlay(carousel) {
    console.log('Starting carousel autoplay');
    const carouselEl = typeof carousel === 'string' ? document.getElementById(carousel) : carousel;
    if (!carouselEl)
        return;
    const intervalAttr = carouselEl.getAttribute('data-interval');
    const interval = intervalAttr ? parseInt(intervalAttr) : 5000;
    console.log('Starting carousel autoplay with interval:', interval);
    setInterval(() => {
        activateNext(carouselEl);
    }, interval);
}
export function activateNext(carousel) {
    console.log('Activating next carousel item');
    const carouselEl = typeof carousel === 'string' ? document.getElementById(carousel) : carousel;
    if (!carouselEl)
        return;
    const container = carouselEl.querySelector('.carousel-inner') ?? null;
    if (!container)
        return;
    const items = container.querySelectorAll('.carousel-item');
    if (items.length === 0)
        return;
    const activeItem = container.querySelector('.carousel-item.active') ?? null;
    let newActiveItem = null;
    if (!activeItem) {
        newActiveItem = items[0];
    }
    else {
        const activeIndex = Array.from(items).indexOf(activeItem);
        const nextIndex = (activeIndex + 1) % items.length;
        newActiveItem = items[nextIndex];
    }
    if (newActiveItem) {
        newActiveItem.classList.add('activating');
        setTimeout(() => {
            newActiveItem?.classList.add('active');
            setTimeout(() => {
                newActiveItem?.classList.remove('activating');
                newActiveItem?.classList.add('active');
                items.forEach((item) => {
                    if (!item.isEqualNode(newActiveItem)) {
                        item.classList.remove('active');
                    }
                });
            }, 600);
        }, 10);
    }
}
